import { Alert, Anchor, Button, Flex, Grid, Text, Title } from '@mantine/core';
import { IconAlertTriangle, IconExternalLink } from '@tabler/icons-react';
import { useState } from 'react';
import { useNavigate } from 'react-router';
import { themeEditorAppEmbedUrl } from '../../helpers/shopifyAppEmbed';
import useFetch from '../../helpers/useFetch';
import ErrorMessage from '../ErrorMessage';

const ActivateDomainFinishedTab = ({ domain, appEmbedIncomplete, appEmbedConfirmedOff }) => {
  const [loading, setLoading] = useState();
  const [error, setError] = useState();

  const navigate = useNavigate();
  const fetch = useFetch();

  const fetchUrl = `/api/admin/accounts/${domain.accountId}/activate`;
  const navigateUrl = `/accounts/${domain.accountId}/domains/${domain.id}/analytics`;

  const activateDomain = () => {
    setLoading(true);
    fetch(fetchUrl, {
      method: 'POST',
    })
      .then(() => {
        setLoading(false);
        navigate(navigateUrl);
      })
      .catch((error) => {
        setError(error);
      });
  };

  if (error) {
    return <ErrorMessage message={error.message} />;
  }

  return (
    <>
      <Flex justify="center">
        <Grid.Col>
          <Title order={2} ta="center">
            {appEmbedIncomplete ? 'Almost there!' : 'You are all set!'}
          </Title>
        </Grid.Col>
      </Flex>
      {appEmbedIncomplete && (
        <Flex justify="center" mb="md">
          <Grid.Col span={{ base: 12, md: 8 }}>
            <Alert color="yellow" icon={<IconAlertTriangle size={16} />}>
              {appEmbedConfirmedOff
                ? 'The Releva.ai app embed is not enabled in your Shopify theme, so nothing will be tracked and no personalization will be shown until you turn it on.'
                : 'We could not confirm that the Releva.ai app embed is enabled in your Shopify theme. If it is not enabled, nothing will be tracked and no personalization will be shown.'}{' '}
              <Anchor href={themeEditorAppEmbedUrl(domain)} target="_blank" rel="noreferrer">
                Enable it now <IconExternalLink size={12} style={{ verticalAlign: 'middle' }} />
              </Anchor>
            </Alert>
          </Grid.Col>
        </Flex>
      )}
      <Flex justify="center">
        <Button
          disabled={loading}
          onClick={() => {
            activateDomain();
            setLoading(true);
          }}
        >
          Go to dashboard
        </Button>
      </Flex>
      <Flex justify="center" mt="md">
        <Grid.Col span={{ base: 12, md: 3 }}>
          {!domain.integrationActive && (
            <Text ta="center" c="dimmed">
              By clicking this button you will start your trial period.
            </Text>
          )}
        </Grid.Col>
      </Flex>
    </>
  );
};

export default ActivateDomainFinishedTab;
